import xhr from "../../Helper/axiosInterceptor";
import {
  URL_SPECIALITY,
  URL_SPECIALITY_STATUS,
} from "../../Config/urlSpeciality/index";

export const speciality = (data) => {
  return xhr(URL_SPECIALITY, "get", null, undefined, undefined, data);
};

export const specialityStatus = (data) => {
  return xhr(URL_SPECIALITY_STATUS, "post", data);
};
